import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import type { CandidateShareUserGroup } from '@recruitee/sharing-container-types';
import { AccessKind } from '@recruitee/sharing-container-types';
import { BoxComponent } from '@recruitee/user-interface';

import { UsersGroupedByAccessKindListItemComponent } from './users-grouped-by-access-kind-list-item/users-grouped-by-access-kind-list-item.component';

@Component({
  selector: 'rt-users-grouped-by-access-kind-list',
  imports: [CommonModule, BoxComponent, UsersGroupedByAccessKindListItemComponent],
  templateUrl: './users-grouped-by-access-kind-list.component.html',
  styleUrl: './users-grouped-by-access-kind-list.component.less',
})
export class UsersGroupedByAccessKindListComponent {
  public readonly AccessKind = AccessKind;

  public usersGroupedByAccessKind = input.required<CandidateShareUserGroup[]>();
}
